import * as React from "react";
import { Select, Option } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/select";
import { Label } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/label";
import { Box } from "@twilio/flex-ui/node_modules/@twilio-paste/box";
import { QueuesStats } from "@twilio/flex-ui";
import { Text } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/text"
import uhaulStore from "../CustomRedux/UhaulStore";

const availableQueues = {
    "All":["all"],
    "Agent-to-Agent":["customer-service-agent", "sales-agent", "roadside-agent", "specialty-agent-chat","roadside-transload","roadside-follow-up","roadside-service-provider-relations"],
    "Application Support": ["application-support"],
    "Customer Service Agent": ["customer-service-agent"],
    "Customer Service Queues": ["general-questions", "rental-equipment", "ubox", "self-storage", "retail sales"],
    "EAlert": ["outstanding-balance"],
    "General Manager": ["general-manager"],
    "Hitch Internal": ["hitch-central"],
    "Moving Help Queues": ["moving-help", "moving-helper"],
    "Patriot Truck Queues": ["patriot-truck"],
    "Retail Group": ["hitch-customer", "boxes-n-moving-supplies", "propane"],
    "U-Haul App Roadside Assistance": ["mobile-advantage"],
    "U-Haul App Accidents": ["mobile-advantage-accident"],
    "Roadside Assistance": ["roadside", "roadside-agent","recovery"],
    "Roadside Connect": ["roadside-transload"],
    "Service Provider Analyst": ["roadside-service-provider-relations"],
    "Sales Agent": ["sales-agent"],
    "Specialty Agent Chat": ["specialty-agent-chat"],
    "Truck Sales": ["truck-sales", "truck-sales-spanish", "truck-sales-titling", "truck-sales-offer"],
    "Truck Share": ["e-mobile-pick-up"],
    "WSS-Operations": ["wss-operations"],
    "WSS-Technical": ["wss-technical"],
    "Other": ["supervisor", "supervisor-monitor"]
}

export class QueueStatsFilter extends React.Component {

    handleOnChange = (e) => {
        try {
            const selectedQueue = e?.target?.value;
            const associatedQueues = availableQueues[selectedQueue];
            const allQueues = uhaulStore.getState().UhaulReducer.allQueues;
            QueuesStats.setFilter(
                (queue) => {
                    const formatedQueueName = queue.friendly_name.toLowerCase();
                    const queueMatch = allQueues.find(queueItem => queueItem.Name.toLowerCase().trim() === formatedQueueName.toLowerCase().trim());
                    return selectedQueue === "All" || associatedQueues.includes(queueMatch && queueMatch.Type ? queueMatch.Type : '')
                }
            );
        } catch(ex) {
            console.error(ex);
        }
    }

    render() {
        return (
            <Box 
                paddingTop="space50"
                paddingBottom="space50"
                paddingLeft="space50"
                maxWidth="400px">
                <Label htmlFor="queueSelection">
                    <Text>Select Queue</Text>
                </Label>
                <Select 
                    id="queueSelection" 
                    onClick={this.handleOnChange}>
                    {Object.keys(availableQueues).map((queue, index) => (
                        <Option key={index} value={queue}>{queue}</Option>
                    ))}
                </Select>
            </Box>
        )
    }

}